import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import type { ClientPropertyVehicleDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailNote } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailNote";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { DetailSectionHeader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailSectionHeader";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";
import { hasAnyDetailValue } from "web_myplann/Shared/Utils/hasAnyDetailValue";

const PageResources = Resources.PortfolioDetail;

type Props = {
	data: ClientPropertyVehicleDetailResponseDTO;
};

export const AutoMotoBasicInfoDetails: FC<Props> = ({ data }) => {
	const { t } = useResource();
	const theme = useTheme();

	const hasDetails = hasAnyDetailValue(
		data.carPurchaseDate,
		data.carRegistration,
		data.carManufactureMonthYear,
		data.carPutIntoService,
		data.description,
	);

	if (!hasDetails) {
		return null;
	}

	return (
		<>
			<DetailSectionHeader
				title={t(Resources.DataCard.BasicInfo.additionalInfo)}
			/>
			<Stack bgcolor={theme.palette.background.paper}>
				<DetailRow
					label={t(PageResources.Property.CarPurchaseDate)}
					value={dateFormatter(data.carPurchaseDate)}
				/>
				<DetailRow
					label={t(PageResources.Property.CarRegistration)}
					value={dateFormatter(data.carRegistration)}
				/>
				<DetailRow
					label={t(PageResources.Property.CreatedAt)}
					value={data.carManufactureMonthYear}
				/>
				<DetailRow
					label={t(PageResources.Property.CarPutIntoService)}
					value={dateFormatter(data.carPutIntoService)}
				/>
				<DetailNote
					label={t(PageResources.Property.AdditionalDescription)}
					text={data.description}
				/>
			</Stack>
		</>
	);
};
